import { z } from 'zod';

import { urlWithoutHttpsRegex } from '../../../helpers/stringHelpers';

export const schema = z.object({
  start: z.date({ error: 'required' }),
  end: z.date({ error: 'required' }),
  eventType: z.enum(['live', 'online', 'secret']),
  venue: z.string().optional(),
  customVenue: z.string().optional(),
  onlineLink: z
    .union([
      z.literal(''),
      z
        .string()
        .trim()
        .refine((value) => urlWithoutHttpsRegex.test(value), {
          message: 'url-format',
        }),
    ])
    .optional(),
});
